module.exports = __webpack_public_path__ + "static/img/brand-11.50c4a0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand-11.png
// module id = zPM2
// module chunks = 1